import Phaser from "phaser";
import { GAME_HEIGHT, GAME_WIDTH } from "./config";
import { ArenaScene } from "./scenes/ArenaScene";
import { BootScene } from "./scenes/BootScene";
import { GameOverScene } from "./scenes/GameOverScene";
import { HUDScene } from "./scenes/HUDScene";
import { ARENA_BG_COLOR } from "./sprites";

export type Vocation = "warrior" | "mage";

export interface PlayerConfig {
  name: string;
  vocation: Vocation;
}

export interface GameConfig {
  player1: PlayerConfig;
  player2: PlayerConfig;
}

/**
 * Boots a fresh Phaser game instance into the given container, seeds the
 * scene registry with the chosen player configs, and starts BootScene
 * (which generates textures and hands off to ArenaScene).
 */
export function createGame(
  parent: HTMLElement,
  config: GameConfig,
): Phaser.Game {
  const game = new Phaser.Game({
    type: Phaser.AUTO,
    parent,
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
    backgroundColor: ARENA_BG_COLOR,
    pixelArt: true,
    physics: {
      default: "arcade",
      arcade: {
        gravity: { x: 0, y: 0 },
        debug: false,
      },
    },
    scene: [BootScene, ArenaScene, HUDScene, GameOverScene],
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
  });

  game.registry.set("config", config);
  return game;
}
